import React from 'react';
import { Container, Box } from '@mui/material';

const AdaptiveContainer = ({ 
  children, 
  maxWidth = "lg", 
  py = 0,
  sx = {},
  ...props 
}) => {
  return (
    <Container 
      maxWidth={maxWidth} 
      sx={{ 
        py: { xs: py * 0.75, md: py }, // Réduire le padding vertical sur mobile
        px: { xs: 2, sm: 3, md: 4 }, // Padding horizontal adaptatif
        ...sx 
      }}
      {...props}
    >
      <Box sx={{
        // '& .MuiTypography-root': {
        //   wordBreak: 'break-word',
        //   hyphens: 'auto',
        // },
        '& .MuiTypography-h1, & .MuiTypography-h2, & .MuiTypography-h3': {
          lineHeight: { xs: 1.2, md: 1.1 },
        },
        '& .MuiTypography-body1, & .MuiTypography-body2': {
          lineHeight: { xs: 1.5, md: 1.6 },
        }
      }}>
        {children}
      </Box>
    </Container>
  );
};

export default AdaptiveContainer; 